// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"504":"72648dd9","550":"e1a948a2","598":"31ad6ce4","723":"be69dd85","769":"86476deb","969":"ee2e670f"}[chunkId] + ".chunk.css";
};